import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@nautilusbio/nb-design-system/styles/all.css';

import App from './App.tsx';
import './styles/index.css';
import styles from './styles/index.module.css';
// Removed temporary navigation instrumentation import. Keep console silence
// module out of the normal bootstrap to avoid hiding important logs.

const rootElement = document.querySelector('#appRoot')!;

rootElement.classList.add(styles.mainAppRoot);

// If we landed via server-side login redirect, set a short navigation lock
// so early route guards/handlers don't immediately redirect back to /login
// while the session cookie is still propagating.
if (typeof window !== 'undefined' && window.location.search.includes('login=success')) {
  try {
    // 10s should be enough for cookie propagation in dev environments
    sessionStorage.setItem('__nav_lock_until', String(Date.now() + 10000));
  } catch {
    // ignore
  }
}

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  const renderApp = () =>
    root.render(
      <StrictMode>
        <App />
      </StrictMode>,
    );

  // Dev-only mock-auth mode (VITE_MOCK_AUTH_STATE): the worker must be
  // registered before the app's first /auth/me request, so render waits on it.
  // DEV guard keeps this path unreachable even if the var were somehow set in
  // a production build. No-op import in every other mode (unset var, CI, prod build).
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_AUTH_STATE) {
    import('./mocks/browser')
      .then(({ startMockAuthIfEnabled }) => startMockAuthIfEnabled())
      .catch((error: unknown) => {
        // eslint-disable-next-line no-console
        console.error('[mock-auth] failed to start MSW worker — rendering app without mocks', error);
      })
      .finally(renderApp);
  } else {
    renderApp();
  }
}
